import * as t from 'io-ts';
import { Authentication } from 'acscp/api/requests/core/baseRequest';
import { FlightRequest } from 'acscp/api/models/flightRequest';
import { BasePutRequest } from 'acscp/api/requests/core/basePutRequest';

export class EditFlightRequestRequest extends BasePutRequest<undefined> {
    constructor(enquiry: FlightRequest, bookingId: string) {
        super(`flight-requests/${bookingId}`, {}, enquiry, t.undefined, Authentication.Login);
    }
}
